import React from "react";
import firebase from "firebase";
import withUser from "../hoc/withUser";
import { withRouter } from "react-router-dom";
import Dropzone from "react-dropzone";
import ImageCompressor from "image-compressor.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import AddAPhoto from "@material-ui/icons/AddAPhoto";
import Img from "react-image";
import {
  Button,
  TextField,
  Snackbar,
  SnackbarContent
} from "@material-ui/core";
// import TextField from "@material-ui/core/TextField";
import Layout from "../layouts/Layout";
// import Snackbar from "@material-ui/core/Snackbar";
// import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { primaryShade1, white } from "../styles/color";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Loading from "./Loading";
import ExifOrientationImg from "react-exif-orientation-img";
import ImageAddCircleOutline from "@material-ui/icons/Edit";
import "../styles/uploadImage.css";
let platform = "other";

if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}

const variantIcon = {
  warning: WarningIcon
};

const styles1 = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);
const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});
class AddCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      imageURL: null,
      phoneNumber: "",
      panNumber: "",
      gstNumber: "",
      tinNumber: "",
      address: "",
      temporaryImageURL: "",
      openSnackBar: false,
      organisationId: "",
      selectedCustomerId: null
    };
  }

  getIcon = (acceptedFiles, rejectedFiles) => {
    const file = acceptedFiles[0];
    if (file == null) {
      alert("Invalid File Type!");
    } else {
      this.setState({
        completed1: true,
        isLoadingUploadImage: 2,
        imageURL: null
      });
    }
    new ImageCompressor(file, {
      quality: 0.55,
      maxWidth: 1500,
      success: result => {
        const image = firebase
          .storage()
          .ref()
          .child("images");
        const ref = image.child(new Date().toString());
        ref.put(file).then(() => {
          ref.getDownloadURL().then(url => {
            const updatedImageURL = url;
            const pictures = this.state.pictures;
            this.setState({
              completed: true,
              pictures,
              imageURL: updatedImageURL,
              isLoadingUploadImage: 3
            });
          });
        });
      }
    });
  };
  componentWillMount() {
    this.initialiseData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initialiseData(nextProps);
  }
  initialiseData(whichProps) {
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }

    if (whichProps.selectedCustomer.length > 0) {
      let customerId = whichProps.selectedCustomer[0].id;
      let customerName = whichProps.selectedCustomer[0].name
        ? whichProps.selectedCustomer[0].name
        : "";
      let customerAddress = whichProps.selectedCustomer[0].address
        ? whichProps.selectedCustomer[0].address
        : "";
      let customerEmail = whichProps.selectedCustomer[0].email
        ? whichProps.selectedCustomer[0].email
        : "";
      let customerPhone = whichProps.selectedCustomer[0].phoneNumber
        ? whichProps.selectedCustomer[0].phoneNumber
        : "";
      let customerGST = whichProps.selectedCustomer[0].gstNumber
        ? whichProps.selectedCustomer[0].gstNumber
        : "";
      let customerTIN = whichProps.selectedCustomer[0].tinNumber
        ? whichProps.selectedCustomer[0].tinNumber
        : "";
      let customerPAN = whichProps.selectedCustomer[0].panNumber
        ? whichProps.selectedCustomer[0].panNumber
        : "";
      let customerImage = whichProps.selectedCustomer[0].imageURL
        ? whichProps.selectedCustomer[0].imageURL
        : null;
      this.setState({
        name: customerName,
        email: customerEmail,
        phoneNumber: customerPhone,
        panNumber: customerPAN,
        gstNumber: customerGST,
        tinNumber: customerTIN,
        address: customerAddress,
        imageURL: customerImage,
        selectedCustomerId: customerId
      });
    } else {
      this.setState({
        name: "",
        email: "",
        phoneNumber: "",
        panNumber: "",
        gstNumber: "",
        tinNumber: "",
        address: "",
        imageURL: null,
        selectedCustomerId: null
      });
    }
  }
  handleChange = name => event => {
    if (name === "panNumber" || name === "gstNumber") {
      this.setState({ [name]: event.target.value.toUpperCase() });
    } else {
      this.setState({ [name]: event.target.value });
    }
  };
  handleOpenSnackBar = () => {
    this.setState({ openSnackBar: true });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openSnackBar: false });
  };
  render() {
    const {
      addCustomer,
      updateCustomer,
      classes,
      operation,
      selectedCustomer
    } = this.props;
    const {
      name,
      email,
      phoneNumber,
      organisationId,
      panNumber,
      gstNumber,
      tinNumber,
      address,
      selectedCustomerId,
      imageURL
    } = this.state;
    return (
      <Layout
        position="static"
        appBar
        appBarTitle={
          (this.props.operation === "addCustomer" ? "ADD" : "UPDATE") +
          " CUSTOMER"
        }
        appBarLeftIcon={true}
      >
        {operation === "updateCustomer" && selectedCustomer.length === 0 ? (
          <Router>
            <div
              style={{
                height: window.innerHeight - 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                flexDirection: "column"
              }}
            >
              <Loading style={{ backgroundColor: "red" }} />
              <span style={{ marginTop: "10px" }}>
                Please wait page is loading......
              </span>
            </div>
          </Router>
        ) : (
          <div
            style={{
              top: "66px",
              position: "absolute",
              width: "100vw",
              height: "calc(100vh - 66px)",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 122px)",
                overflowY: "scroll"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
                onClick={this.onDrop}
              >
                <Dropzone onDrop={this.getIcon} accept="image/*">
                  {({ getRootProps, getInputProps, isDragActive }) => {
                    return (
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <u>
                          {!imageURL ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                height: "140px",
                                width: "140px",
                                margin: "10px"
                              }}
                            >
                              <AddAPhoto
                                style={{
                                  color: primaryShade1,
                                  height: "140px",
                                  width: "140px"
                                }}
                              />
                            </div>
                          ) : platform === "ios" ? (
                            <div
                              className="imgContainer"
                              style={{
                                display: "flex",
                                flexFlow: "wrap-reverse"
                              }}
                            >
                              <Img
                                src={imageURL}
                                alt={name.charAt(0).toUpperCase()}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                  height: "140px",
                                  width: "140px",
                                  objectFit: "cover",
                                  borderRadius: "50%"
                                }}
                                onLoad={() => {
                                  return (
                                    <CircularProgress
                                      style={{
                                        height: "100px",
                                        width: "100px"
                                      }}
                                    />
                                  );
                                }}
                              />
                              <div className="overlayImageEditIcon">
                                <ImageAddCircleOutline />
                              </div>
                            </div>
                          ) : (
                            <div
                              className="imgContainer"
                              style={{
                                display: "flex",
                                flexFlow: "wrap-reverse"
                              }}
                            >
                              <ExifOrientationImg
                                src={imageURL}
                                alt={name.charAt(0).toUpperCase()}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                  height: "140px",
                                  width: "140px",
                                  objectFit: "cover",
                                  imageOrientation: `from-image`,
                                  borderRadius: "50%"
                                }}
                                onLoad={() => {
                                  return (
                                    <CircularProgress
                                      style={{
                                        height: "100px",
                                        width: "100px"
                                      }}
                                    />
                                  );
                                }}
                              />
                              <div className="overlayImageEditIcon">
                                <ImageAddCircleOutline />
                              </div>
                            </div>
                          )}
                        </u>
                      </div>
                    );
                  }}
                </Dropzone>
              </div>
              <TextField
                id="outlined-bare"
                type="text"
                value={name}
                onChange={this.handleChange("name")}
                margin="normal"
                variant="outlined"
                required={true}
                className={classNames(classes.margin)}
                label="Name"
                InputLabelProps={{
                  shrink: true
                }}
              />

              <TextField
                id="outlined-bare"
                name="phoneNumber"
                type="number"
                onChange={this.handleChange("phoneNumber")}
                value={phoneNumber}
                margin="normal"
                variant="outlined"
                className={classNames(classes.margin)}
                label="Phone Number"
                InputLabelProps={{
                  shrink: true
                }}
              />

              <TextField
                id="outlined-bare"
                name="email"
                placeholder="xyz@example.com"
                type="email"
                onChange={this.handleChange("email")}
                value={email}
                margin="normal"
                variant="outlined"
                label="Email"
                className={classNames(classes.margin)}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-bare"
                type="text"
                value={panNumber}
                onChange={this.handleChange("panNumber")}
                margin="normal"
                variant="outlined"
                className={classNames(classes.margin)}
                label="Pan Number"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-bare"
                type="text"
                value={gstNumber}
                onChange={this.handleChange("gstNumber")}
                margin="normal"
                variant="outlined"
                className={classNames(classes.margin)}
                label="GST Number"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-bare"
                name="tinNumber"
                type="number"
                onChange={this.handleChange("tinNumber")}
                value={tinNumber}
                margin="normal"
                variant="outlined"
                className={classNames(classes.margin)}
                label="TIN Number"
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                id="outlined-bare"
                name="address"
                multiline
                rows="4"
                rowsMax="4"
                onChange={this.handleChange("address")}
                margin="normal"
                variant="outlined"
                label="Address"
                value={address}
                className={classNames(classes.margin)}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "56px",
                position: "absolute",
                bottom: "0px",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Button
                variant="contained"
                color={primaryShade1}
                onClick={e => {
                  e.preventDefault();
                  if (operation === "addCustomer") {
                    if (name !== "") {
                      const customer = {
                        name: this.state.name,
                        email: this.state.email,
                        imageURL: this.state.imageURL,
                        phoneNumber: this.state.phoneNumber,
                        panNumber: this.state.panNumber,
                        gstNumber: this.state.gstNumber,
                        tinNumber: this.state.tinNumber,
                        address: this.state.address,
                        userId: this.props.user.uid,
                        isActive: true,
                        organisationId: organisationId,
                        createdAt: new Date()
                      };
                      addCustomer(customer);
                      this.props.history.goBack();
                    } else {
                      this.handleOpenSnackBar();
                    }
                  } else {
                    if (name !== "") {
                      updateCustomer(
                        selectedCustomerId,
                        name,
                        email,
                        phoneNumber,
                        panNumber,
                        gstNumber,
                        tinNumber,
                        address,
                        imageURL
                      );
                      this.props.history.goBack();
                    } else {
                      this.handleOpenSnackBar();
                    }
                  }
                }}
                style={{
                  backgroundColor: primaryShade1,
                  color: "white",
                  width: "100%",
                  height: "100%"
                }}
              >
                {operation === "addCustomer" ? "ADD" : "UPDATE"}
              </Button>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              open={this.state.openSnackBar}
              autoHideDuration={3000}
              onClose={this.handleClose}
            >
              <MySnackbarContentWrapper
                variant="warning"
                message="Customer Name Must Be Filled before Adding Customer....!"
              />
            </Snackbar>
          </div>
        )}
      </Layout>
    );
  }
}

export default withRouter(withUser(withStyles(stylesMain)(AddCustomer)));
